<div class="container">
  <app-loading [showLoading]="isLoading"></app-loading>
  <h1 class="header">
    <div class="title">BlueBean の連携</div>
    <button
      type="button"
      mat-icon-button
      class="close-button"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <form class="main" (submit)="onSubmit($event)">
    @if (isEditMode) {
      <p class="description">
        現在 BlueBean 連携は<strong>有効</strong>です。業務 ID
        やスキルマップだけを変更する場合は、ドメイン・ユーザー名・パスワードを空欄のまま保存できます。接続情報を変更する場合は
        3 つ全て再入力してください。
      </p>
    } @else {
      <p class="description">
        BlueBean
        のドメイン・管理者ユーザー名・パスワードを入力して連携を開始します。保存時に
        BlueBean API で接続確認を行います。
      </p>
    }

    <div class="form">
      <div class="field">
        <label class="label" for="bluebean-domain">
          ドメイン
          @if (!isEditMode) {
            <span> *</span>
          }
          :
        </label>
        <div class="input-with-error">
          <div class="value">
            <input
              id="bluebean-domain"
              class="input"
              [class.error]="domain.touched && domain.invalid"
              placeholder="例: example.bluebean.jp"
              [formControl]="domain"
            />
          </div>
          @if (domain.touched && domain.hasError('required')) {
            <div class="input-error">ドメインは必須です</div>
          }
        </div>
      </div>

      <div class="field">
        <label class="label" for="bluebean-username">
          ユーザー名
          @if (!isEditMode) {
            <span> *</span>
          }
          :
        </label>
        <div class="input-with-error">
          <div class="value">
            <input
              id="bluebean-username"
              class="input"
              [class.error]="username.touched && username.invalid"
              placeholder="管理者ユーザー名"
              [formControl]="username"
            />
          </div>
          @if (username.touched && username.hasError('required')) {
            <div class="input-error">ユーザー名は必須です</div>
          }
        </div>
      </div>

      <div class="field">
        <label class="label" for="bluebean-password">
          パスワード
          @if (!isEditMode) {
            <span> *</span>
          }
          :
        </label>
        <div class="input-with-error">
          @if (isEditMode) {
            <div class="input-help">
              ※変更する場合のみ入力してください。空欄のまま保存すると既存のパスワードを維持します
            </div>
          }
          <div class="value secret-value">
            <input
              id="bluebean-password"
              class="input"
              [type]="isPasswordVisible ? 'text' : 'password'"
              autocomplete="new-password"
              [class.error]="password.touched && password.invalid"
              [placeholder]="
                isEditMode ? '変更する場合のみ入力' : '管理者パスワード'
              "
              [formControl]="password"
            />
            <button
              type="button"
              class="secret-visibility-button"
              [attr.aria-label]="
                isPasswordVisible ? 'パスワードを隠す' : 'パスワードを表示'
              "
              (click)="isPasswordVisible = !isPasswordVisible"
            >
              <mat-icon>
                {{ isPasswordVisible ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>
          </div>
          @if (password.touched && password.hasError('required')) {
            <div class="input-error">パスワードは必須です</div>
          }
        </div>
      </div>

      <div class="field">
        <label class="label" for="bluebean-campaign-ids">業務ID * :</label>
        <div class="input-with-error">
          <div class="value">
            <input
              id="bluebean-campaign-ids"
              class="input"
              [class.error]="
                campaignIdsInput.touched && campaignIdsInput.invalid
              "
              placeholder="例: 1, 2, 3"
              aria-describedby="bluebean-campaign-ids-hint"
              [formControl]="campaignIdsInput"
            />
          </div>
          <span id="bluebean-campaign-ids-hint" class="input-help"
            >数字のカンマ区切りで指定。</span
          >
          @if (
            campaignIdsInput.touched && campaignIdsInput.hasError('required')
          ) {
            <div class="input-error">業務IDは必須です</div>
          }
        </div>
      </div>

      <div class="field">
        <label class="label" for="bluebean-skill-map">スキルマップ * :</label>
        <div class="input-with-error">
          <div class="value">
            <select
              id="bluebean-skill-map"
              class="input"
              [class.error]="skillMapId.touched && skillMapId.invalid"
              [formControl]="skillMapId"
            >
              <option value="" disabled>選択してください</option>
              @for (map of skillMaps; track map) {
                <option [value]="map.id">
                  {{ map.name }}
                </option>
              }
            </select>
          </div>
          @if (skillMapId.touched && skillMapId.hasError('required')) {
            <div class="input-error">スキルマップは必須です</div>
          }
          @if (skillMapLoadError) {
            <div class="input-error">
              {{ skillMapLoadError }}
            </div>
          }
        </div>
      </div>

      <div class="field">
        <label class="label" for="bluebean-default-tag">デフォルトタグ :</label>
        <div class="input-with-error">
          <div class="value">
            <select
              id="bluebean-default-tag"
              class="input"
              aria-describedby="bluebean-default-tag-hint"
              [formControl]="defaultTagMasterId"
            >
              <option value="">付与しない</option>
              @for (tagMaster of assessmentTagMasters; track tagMaster.id) {
                <option [value]="tagMaster.id">
                  {{ tagMaster.name }}
                </option>
              }
            </select>
          </div>
          <span id="bluebean-default-tag-hint" class="input-help"
            >BlueBean から取り込んだ通話すべてに付与するタグです。</span
          >
          @if (isCurrentTagDisabled) {
            <div class="input-error">
              設定中のタグは無効化されています。このまま保存するとタグ設定は解除されます。
            </div>
          }
          @if (tagMasterLoadError) {
            <div class="input-error">
              {{ tagMasterLoadError }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="footer">
      <button type="button" rectangle variant="secondary" (click)="close()">
        キャンセル
      </button>
      <button
        type="submit"
        rectangle
        variant="primary"
        [disabled]="
          isLoading || formGroup.invalid || tagMasterLoadError != null
        "
      >
        保存
      </button>
    </div>
  </form>
</div>
